module.exports = __webpack_public_path__ + "img/reports-logo.1739c321.svg";